import {fromURL, listToString, stringToList, toUrl} from "./ObjectToURLUtil";
import {JSCriteriaBuilder} from "./JSCriteriaBuilder";

let IN_VALUES = "inv";
let RIGHT_HAND_SIDE = "rhs";
let OPERATOR = "op";
let ID = "id";
let RELATIONSHIP = "rltn";
let VALUE = "vlu";

export class CriteriaExpressionSerializer {
    constructor() {

    }

    /**
     *
     * @param {namaTypes.DTOExperssion} expression
     */
    toProperties(expression) {
        let map = new Map();
        map.set(ID, expression.field);
        map.set(OPERATOR, expression.operator ? expression.operator : "");
        map.set(RIGHT_HAND_SIDE, expression.rightHandSide ? expression.rightHandSide : "");
        map.set(RELATIONSHIP, expression.relation ? expression.relation : "");
        map.set(IN_VALUES, listToString(expression.inValues));
        return map;
    }

    fromProperties(properties) {
        /**
         * @type {namaTypes.DTOExperssion}
         */
        let dtoExpression = {};
        dtoExpression.field = properties[ID];
        if (properties[OPERATOR])
            dtoExpression.operator = properties[OPERATOR];
        dtoExpression.rightHandSide = properties[RIGHT_HAND_SIDE];
        if (properties[RELATIONSHIP])
            dtoExpression.relation = properties[RELATIONSHIP];
        dtoExpression.inValues = stringToList(properties[IN_VALUES]);
        return dtoExpression;
    }

    toURL(criteria) {
        if (!criteria)
            return "";
        return toUrl(criteria.expressions, this);
    }

    criteriaFromURL(url) {
        let criteria = new JSCriteriaBuilder();
        criteria.expressions = fromURL(url, this);
        return criteria;
    }
}

export class QuestionFieldsSerializer {
    constructor() {

    }

    toProperties(object) {
        let map = new Map();
        map.set(ID, object.id);
        map.set(VALUE, object.value);
        return map;
    }

    fromProperties(properties) {
        /**
         * @type {namaTypes.DTOFilledQuestionField}
         */
        let filledQuestion = {};
        filledQuestion.id = properties[ID];
        filledQuestion.value = properties[VALUE];
        return filledQuestion;
    }

    toURL(filledQuestionFields) {
        return toUrl(filledQuestionFields, this);
    }

    questionsFromURL(url) {
        return fromURL(url, this);
    }
}